import React from 'react'
import ttJoseph from '../Assets/images/ttJoseph.jpg'
import Samuel from '../Assets/images/Samuel.jpg'
import joseph from '../Assets/images/ksjoseph.png'
import varghesephilip from '../Assets/images/varghesephilip.png'
import kvjose from '../Assets/images/kvjose.jpg'
import Footer from '../Home/Footer'

export default function About() {
    return (
        <>
            <div className='aboutUsContainer'>
                <div className='aboutUsContent'>
                    <div className='aboutTextContent'>
                        <h3 className='aboutUsHeader'>History of Karnataka Bible College </h3>
                        <p className='aboutuscontenttext'>
                            Remembering the founder: In this juncture we remember the labour of the great visionary late Pr T.T Joseph and others whose leadership was helpful for this institution. By trusting in the Lord, KBC started in a hired facility at IPC Viveknagar in the year 1991. Brother K.C Pappachan and Bro. P.M Thomas and believers of Vivekanagar church supported him to start KBC. First batch of 20 students with G Th were graduated in 1993. Pastor A M Jacob was served as the warden cum supervision of the college then. In 1995 this institute was shifted to the newly constructed building of late Bro. K I Abraham at Horamavu. After the completion of IPC Headquarters building at Agara in 1998, the college began to function with all the facilities available there. We praise God for His Faithfulness throughout these years and we remember all the past and present faculty members for their valuable contribution that helped KBC to stand as a unique institution.
                            We started our journey with 20 students in the year of 1991, and we were able to send out hundreds of trained graduates to the vineyard of the Lord in Karnataka and throughout the globe.
                            When Pr. T.T Joseph was promoted to Glory in 2010, according to his desire Pr. Sam George (the present IPC General Secretary) became the Principal and Pastor John Mathew assisted him. We remember Bro. Tom Joseph the eldest son of T T Joseph who came forward to sponsor KBC financially. Every member of  the Thottumalil family encouraged KBC with prayer and moral support. We also remember Late Pastor T.T Thomas, Pr. Valson Abraham (present IPC General President), Pr. M.J David who were also a great support to us in all manner.
                        </p>
                    </div>
                    <div className='photoContent'>
                        <div className='photoImgContent'>
                            <img
                                className='ttJoseph'
                                src={ttJoseph}
                                alt="TT_Joseph"
                            />
                        </div>
                    </div>
                </div>
                <div className='aboutUsContent'>
                    <div className='aboutTextContent'>
                        <h3 className='aboutUsHeader'>From Principal's Desk</h3>
                        <p className='aboutuscontenttext'>
                            The IPC Karnataka Bible College is one of the prominent theological institutions in Karnataka,
                            specialized in equipping students with the Word of God to "reach the unreached people groups". Late Pastor T.T.Joseph handed over the institute
                            in the year 2010 and from then onwards God enabled me to hold the post of Principal. The contributions from Thottumalil family, especially Bro.Tom Joseph,
                            Pr.M.J.David, Bahrain, and IPC churches in Karnataka are the financial resources for the smooth functioning of the institution.
                            At present 100 students, both Residential and Non Residential are getting trainning for entering into various ministries in Karnataka.
                            <br></br>
                            The College is well supported by eminent faculties and office bearers. We emphasis the Command of our Lord Jesus Christ to preach the Gospel to the World(Matt 28:18)
                            <br></br>
                            <br></br>
                            <b>Pr.Samuel George</b>
                            <br></br>
                            Principal
                        </p>
                    </div>
                    <div className='photoContent'>
                        <img
                            className='ttJoseph'
                            src={Samuel}
                            alt="Samuel George"
                        />
                    </div>
                </div>

                <div className='aboutUsContent'>
                    <div className='aboutTextContent'>
                        <h3 className='aboutUsHeader'>From the President of IPCKS</h3>
                        <p className='aboutuscontenttext'>
                            Our Lord Jesus Christ, commanded us to go around the world,
                            preach the Good News, make disciples, and teach them all that
                            He has commanded. A Christian's Primary responsibility in this
                            perverse and wicked generation is to share the Good News of
                            Jesus Christ with the perishing multitudes. Those who receive the
                            Word turn their hearts to Jesus and become disciples.
                            <br></br>
                            The Karnataka Bible College aims at obeying the <b>Great Commission of our Lord. </b>
                            In the present age, where heresies and false teachings are sometimes indistinguishable,
                            we equip the young dedicated workers of the Lord to biblically align their ministry
                            and reach out to th masses.
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <b>Pr.K S Joseph</b>
                            <br></br>
                            State President, IPC Karnataka State
                        </p>
                    </div>
                    <div className='photoContent'>
                        <img
                            className='ttJoseph'
                            src={joseph}
                            alt="ks_Joseph"
                        />
                    </div>
                </div>
                <div className='aboutUsContent'>
                    <div className='aboutTextContent'>
                        <h3 className='aboutUsHeader'>Words from the Registrar</h3>
                        <p className='aboutuscontenttext'>
                            Karnataka Bible College Stands for equipping saints to "correctly
                            handle the word of Truth" and for giving intensive training to
                            become "approved workers" (2 Tim 2:15). We strongly believe that
                            <b> Bible is supreme authority and is God's revelation in history. </b>
                            It is inspired, inerrant and infallible. There is no higher authority
                            than the Word of God and its authority is timeless and unchanging inspite of all
                            the philosophical and theological transitions taking place in this generation.
                            We acknowledge its power to mould the conscience, conviction and character of those
                            who devote for learning. Also, we affirm that is has the authority to transform all
                            the cultural practices and traditions tainted with evil and impure influence.
                            <br></br>
                            <br></br>
                            KBC has been in an upward path for the last 30 years, and dedicated
                            for equipping young people to bring God's rule on earth through various
                            ministries and missions. Thank God for those who have invested time, talents,
                            and treasures for the growth and development of the institution. We continue the visionaryof the poineers
                            to equip soldiers, stewards and servents for the Kingdom purpose and invite well wishers and visionaries to become
                            partners to fulfil the Great Commission.
                            <br></br>
                            <br></br>
                            <b>Dr. Varughese Philip, Ph.D</b>
                            <br></br>
                            Registrar
                        </p>
                    </div>
                    <div className='photoContent'>
                        <img
                            className='ttJoseph'
                            src={varghesephilip}
                            alt="Varughese"
                        />
                    </div>
                </div>
                <div className='aboutUsContent'>
                    <div className='aboutTextContent'>
                        <h3 className='aboutUsHeader'>Words from the Administrator</h3>
                        <p className='aboutuscontenttext'>
                            Warm Christian Greetings!
                            <br></br>
                            The Greatest need of the hour in India, especially the State of Karnataka
                            is a set of trained leaders.
                            <br></br>
                            There are 3 types of leaders:
                            <br></br>
                            God made leaders (Born Leader's)
                            <br></br>
                            Self made leaders, and Man made leaders
                            <br></br>
                            Our Lord Jesus was a 'Born Leader' and an example of <b>servant leadership</b>. A
                            servant leader will never ever think that he is the only capable person. Once our General
                            President Pr.Dr.Valson Abraham quoted a phrase from E M Bounds Sermon, "Man look for better methods, but God looks for better Men."
                            KBC also has a vision to recognise the potential leaders to train, mould, equip, and send them to the
                            vineyard of our Lord.

                            <br></br>
                            <br></br>
                            <b>Pr. K V Jose</b>
                            <br></br>
                            Administrator
                        </p>
                    </div>
                    <div className='photoContent'>
                        <img
                            className='ttJoseph'
                            src={kvjose}
                            alt="K V Jose"
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
